var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 198,
    viewBox: "0 0 213 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 3.21853,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 20.3841,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 37.5495,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 71.8806,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 54.7151,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 89.0461,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 108.484,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.543,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.978,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.413,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.848,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.717,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.282,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 108.484,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.45652,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8913,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.326,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 108.483,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 125.649,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 142.814,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 177.145,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.7608,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.6303,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 159.98,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.1956,
    cy: 194.311,
    rx: 3.45652,
    ry: 3.21853,
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDots);
export default __webpack_public_path__ + "static/media/white-dots.c6c8598da4a8d9454ed165fb26ea6035.svg";
export { ForwardRef as ReactComponent };